"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthHttpError = void 0;
const http_status_codes_1 = __importDefault(require("http-status-codes"));
const AuthError_1 = require("../../Error/AuthError");
class AuthHttpError extends AuthError_1.AuthError {
    constructor(code, message, key, token) {
        super(message);
        this.code = code;
        this.key = key;
        this.token = token;
        this.statusCode = http_status_codes_1.default.getStatusText(this.code);
    }
}
exports.AuthHttpError = AuthHttpError;
//# sourceMappingURL=AuthHttpError.js.map